/* Judge.me review widget: runtime accessibility fixes (companion to judgeme-accessibility.css).
   The widget is injected and re-rendered by the app, so we patch on every DOM change.
   - Per-review star ratings are role="img" with tabindex="0": eight tab stops that do nothing.
     They stay in the reading order (aria-label kept); only the tab stop is removed.
   - Pagination arrows (first/prev/next/last) reuse the target page's label ("Page 2"),
     so three links share one name (WCAG 2.4.4). They get their own labels, from the theme locale.
   - The current page link is marked aria-current="page". */
(function () {
  const script = document.currentScript;
  const labels = {
    first: script && script.dataset.labelFirst,
    prev: script && script.dataset.labelPrevious,
    next: script && script.dataset.labelNext,
    last: script && script.dataset.labelLast
  };

  const patch = () => {
    document.querySelectorAll('.jdgm-rev__rating[tabindex="0"]').forEach((el) => {
      el.setAttribute('tabindex', '-1');
    });

    const arrows = [
      ['[class*="jdgm-paginate__first"]', labels.first],
      ['[class*="jdgm-paginate__prev"]', labels.prev],
      ['[class*="jdgm-paginate__next"]', labels.next],
      ['[class*="jdgm-paginate__last"]', labels.last]
    ];
    arrows.forEach(([selector, label]) => {
      if (!label) return;
      document.querySelectorAll('.jdgm-paginate ' + selector).forEach((el) => {
        if (el.getAttribute('aria-label') !== label) el.setAttribute('aria-label', label);
      });
    });

    document.querySelectorAll('.jdgm-paginate .jdgm-paginate__page').forEach((el) => {
      const isCurrent = el.classList.contains('jdgm-curt');
      if (isCurrent && el.getAttribute('aria-current') !== 'page') el.setAttribute('aria-current', 'page');
      if (!isCurrent && el.hasAttribute('aria-current')) el.removeAttribute('aria-current');
    });
  };

  let timer = null;
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(patch, 100);
  });

  const start = () => {
    patch();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
